import { InboxListItemContent } from 'Automations/components'
import { useManualTaskListItemContentToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskListItemContentToolkit'
import { getManualTaskStatusIcon } from 'Automations/nodeDefinitions/hooks/getManualTaskStatusIcon'
import {
  InvoiceUpdateReviewInput,
  InvoiceUpdateReviewOutcome
} from '../../types'
import {
  getInvoiceReviewTitle,
  mapInputToViewModel
} from '../../invoiceUpdateReview.helpers'
import { InvoiceReviewCustomerLogo } from '../InvoiceReviewCustomerLogo'

export const InvoiceUpdateReviewListItemContent = ({
  taskId,
  isSelected,
  hideUnreadIndicator,
  onClick
}: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => {
  const { manualTask, isUnread, preload } =
    useManualTaskListItemContentToolkit<InvoiceUpdateReviewInput>({ taskId })

  if (!manualTask?.input) {
    return <InboxListItemContent.Loading />
  }

  const { summary, invoice } = mapInputToViewModel(manualTask.input)

  // A dismissed review completes as COMPLETED (not CANCELLED), so the status
  // alone can't tell it apart from a confirmed one — read the recorded outcome
  // so a dismissal shows the negative (X) icon rather than the success check.
  const outcome = (manualTask.output as InvoiceUpdateReviewOutcome | null)
    ?.outcome
  const statusIcon = getManualTaskStatusIcon(manualTask.status, outcome)

  return (
    <InboxListItemContent
      isSelected={isSelected}
      isUnread={hideUnreadIndicator ? undefined : isUnread}
      onClick={onClick}
      onPreload={preload}
      title={getInvoiceReviewTitle(invoice)}
      description={summary}
      createdAt={manualTask.createdAt}
      statusIcon={statusIcon}
      icon={
        <InboxListItemContent.TaskIcon isSelected={isSelected}>
          <InvoiceReviewCustomerLogo
            customerId={invoice.customerId}
            data-testid="watchtower.invoiceUpdateReview.listItem.logo"
          />
        </InboxListItemContent.TaskIcon>
      }
    />
  )
}
